import type { TimelineItemType } from '@witmetrics/unison-core';
import ToggleBlock, { ToggleOption } from '@/components/ToggleBlock';
import { classes } from './utils';

export type TimelineToggleProps = {
  value: TimelineItemType;
  onChange: (value: TimelineItemType) => void;
};

export default function TimelineToggle({
  value,
  onChange,
}: TimelineToggleProps) {
  return (
    <ToggleBlock<TimelineItemType>
      className={classes.toggleBlock}
      value={value}
      onChange={onChange}>
      <ToggleOption className={classes.option} value="ALL">
        All
      </ToggleOption>
      <ToggleOption className={classes.option} value="KEYPOINTS">
        Keypoints
      </ToggleOption>
      <ToggleOption className={classes.option} value="NOTES">
        Notes
      </ToggleOption>
    </ToggleBlock>
  );
}
